import { type FC, type ComponentProps } from "react";
import {
  Salaries,
  type SalariesProps,
} from "@legacy_user_frontend/components/projects/button_contents/src/top_contents/src/Salaries";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import {
  imageContents,
  imageContentsIs1Column,
  titleText,
  awardsLabels,
  awardsLabel,
} from "@legacy_user_frontend/components/projects/button_contents/src/styles.css";
import { ConsiderationNumInformation } from "@userFrontend/features/publication/components/ConsiderationNumInformation";
import { WorkImageSlider } from "@userFrontend/features/publication/components/WorkImageSlider";
import { AlbumContents } from "@userFrontend/features/publication/components/AlbumContents";
import { type OsType } from "@root/shared/types/type";
import * as styles from "./styles.css";

export type TopContentsProps = {
  isSp: boolean;
  isBiyo: boolean;
  isWebview: boolean;
  osType: OsType;
  pageType: string;
  images: ComponentProps<typeof WorkImageSlider>["images"] | null;
  albumCategoryItems: ComponentProps<typeof AlbumContents>["albumCategoryItems"];
  imgSrc: string;
  dummyImgPath: string;
  isContractRunning: boolean;
  awardsLabel?: {
    awardsLabelRank?: string;
    awardsLabelText?: string;
  };
  considerationContents: {
    considerationDisplayFlag: boolean;
    considerationNumText: string;
  };
  salaryContents: SalariesProps["salaryContents"];
  title?: string;
  workCode: string;
  isEnterable: boolean;
};

export const TopContents: FC<TopContentsProps> = ({
  isSp,
  isBiyo,
  isWebview,
  osType,
  pageType,
  images,
  albumCategoryItems,
  imgSrc,
  dummyImgPath,
  isContractRunning,
  awardsLabel: awardsLabelProp,
  considerationContents: { considerationDisplayFlag, considerationNumText },
  salaryContents,
  title,
  workCode,
  isEnterable,
}) => {
  return (
    <>
      {pageType === "detail" && (
        <>
          {images && isContractRunning && (
            <div className={styles.imageAlbumWrapper}>
              <WorkImageSlider images={images} pcWidthStyle={!isEnterable ? "wide" : "narrow"} />
              <div className={styles.imageButtonWrapper}>
                <AlbumContents
                  isBiyo={isBiyo}
                  isShowWorkDetailBackButton={!(osType === "iOS" && isWebview)}
                  albumCategoryItems={albumCategoryItems}
                />
              </div>
            </div>
          )}
        </>
      )}
      {pageType !== "detail" && imgSrc && isContractRunning && (
        <div className={`${imageContents} ${!workCode ? imageContentsIs1Column : ""}`}>
          <LazyLoadImage src={imgSrc} dummyImgPath={dummyImgPath} alt="" width={657} height={370} />
        </div>
      )}
      {isSp && workCode && pageType === "detail" && (
        <>
          {awardsLabelProp &&
            awardsLabelProp?.awardsLabelRank &&
            awardsLabelProp?.awardsLabelText &&
            pageType === "detail" && (
              <div className={awardsLabels}>
                <span className={awardsLabel} data-rank={awardsLabelProp.awardsLabelRank}>
                  {awardsLabelProp.awardsLabelText}
                </span>
              </div>
            )}
          {considerationDisplayFlag && isEnterable && (
            // isSpの場合(TAB,SP想定)表示される
            <div style={{ margin: "16px 0" }}>
              <ConsiderationNumInformation considerationNumText={considerationNumText} />
            </div>
          )}
          {title && <p className={titleText}>{title}</p>}
          {isContractRunning && <Salaries salaryContents={salaryContents} />}
        </>
      )}
    </>
  );
};
